"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_TIME_FORMAT = void 0;
/** date-fns format: "2026-03-02 09:28 PM" */
exports.DATE_TIME_FORMAT = 'yyyy-MM-dd hh:mm a';
